import CakeValley from '../../Assets/CakeValley.PNG';
import CarRentalService from '../../Assets/carRentalService.PNG';
import CookingMaster from '../../Assets/CookingMaster.PNG';
import EasyTransport from '../../Assets/easyTransport.PNG';
import EmaJohn from '../../Assets/ema-john-simple.PNG';
import TeamSelection from '../../Assets/teamSelection.PNG';
const linkArray = [
    {
        name: "Car Rental Services",
        image: CarRentalService,
        demoLink: "https://molla-rent-a-car.web.app/home",
        gitLink: "https://github.com/matutul/car-rent-service"
    },
    {
        name: "Easy Transport",
        image: EasyTransport,
        demoLink: "https://easy-transport-system.web.app",
        gitLink: "https://github.com/matutul/react-auth-matutul"
    },
    {
        name: "Cake Valley",
        image: CakeValley,
        demoLink: "https://cake-valley-authentication.web.app",
        gitLink: "https://github.com/matutul/full-stack-client"
    },
    {
        name: "Cooking Master",
        image: CookingMaster,
        demoLink: "https://matutul.github.io/cooking-master",
        gitLink: "https://github.com/matutul/cooking-master"
    },
    {
        name: "Team Selection",
        image: TeamSelection,
        demoLink: "https://jovial-fermat-0e5be8.netlify.app",
        gitLink: "https://github.com/matutul/simple-react-matutul"
    },
    {
        name: "Ema John",
        image: EmaJohn,
        demoLink: "https://dreamy-franklin-a38eb1.netlify.app",
        gitLink: "https://github.com/matutul/ema-john-simple"
    }
];
export default linkArray;